<template>
  <v-container>
    <v-card>
      <v-toolbar
        flat
        color="primary"
        dark
      >
        <v-icon left>mdi-test-tube</v-icon>
        <v-toolbar-title>Test Bulk Access Modal</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pa-6">
        <v-row>
          <v-col cols="12">
            <v-alert
              type="info"
              text
              border="left"
            >
              <strong>Test Page</strong><br>
              This page allows you to test the Bulk Access Management feature with mock data.
              Click the button below to open the modal.
            </v-alert>
          </v-col>

          <v-col cols="12" md="6">
            <v-card outlined>
              <v-card-title class="subtitle-1">Test Configuration</v-card-title>
              <v-card-text>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>Course ID</v-list-item-subtitle>
                      <v-list-item-title>{{ testCourseId }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>Package ID</v-list-item-subtitle>
                      <v-list-item-title>{{ testPackageId }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>Package Name</v-list-item-subtitle>
                      <v-list-item-title>{{ testPackageName }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>Using Mock Data</v-list-item-subtitle>
                      <v-list-item-title>
                        <v-chip small :color="isUsingMock ? 'warning' : 'success'">
                          {{ isUsingMock ? 'Yes (Development)' : 'No (Real API)' }}
                        </v-chip>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card outlined>
              <v-card-title class="subtitle-1">Actions</v-card-title>
              <v-card-text>
                <v-btn
                  color="primary"
                  large
                  block
                  @click="dialog = true"
                >
                  <v-icon left>mdi-folder-multiple</v-icon>
                  Open Bulk Access Modal
                </v-btn>

                <div class="mt-4">
                  <p class="caption grey--text">
                    Last update: {{ lastUpdate || 'Never' }}
                  </p>
                  <p class="caption grey--text">
                    Updates count: {{ updateCount }}
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card outlined>
              <v-card-title class="subtitle-1">Console Output</v-card-title>
              <v-card-text>
                <v-alert
                  v-if="logs.length === 0"
                  text
                  type="info"
                >
                  No logs yet. Open the modal and interact with it to see logs.
                </v-alert>
                <v-list
                  v-else
                  dense
                  class="pa-0"
                  style="max-height: 300px; overflow-y: auto"
                >
                  <v-list-item
                    v-for="(log, index) in logs"
                    :key="index"
                    :class="log.type + '--text'"
                  >
                    <v-list-item-icon>
                      <v-icon :color="log.type" small>
                        {{ log.type === 'success' ? 'mdi-check-circle' : log.type === 'error' ? 'mdi-alert-circle' : 'mdi-information' }}
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption">
                        {{ log.timestamp }}
                      </v-list-item-subtitle>
                      <v-list-item-title>{{ log.message }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Bulk Access Modal -->
    <bulk-access-modal
      v-model="dialog"
      :course-id="testCourseId"
      :package-id="testPackageId"
      :package-name="testPackageName"
      @updated="onUpdated"
    />
  </v-container>
</template>

<script>
import BulkAccessModal from '@/components/course-access/BulkAccessModal.vue'
import courseAccessService from '@/services/courseAccessService'

export default {
  name: 'TestBulkAccess',

  components: {
    BulkAccessModal
  },

  data: () => ({
    dialog: false,
    testCourseId: 47,
    testPackageId: 119,
    testPackageName: 'Преміум пакет',
    lastUpdate: null,
    updateCount: 0,
    logs: []
  }),

  computed: {
    isUsingMock() {
      return courseAccessService.isUsingMock()
    }
  },

  methods: {
    onUpdated() {
      this.lastUpdate = new Date().toLocaleString('uk-UA')
      this.updateCount++

      this.addLog('success', 'Access updated successfully!')

      if (this.$toasted) {
        this.$toasted.success('✅ Access updated successfully')
      }

      console.log('✅ Test: Access updated', {
        timestamp: this.lastUpdate,
        count: this.updateCount
      })
    },

    addLog(type, message) {
      this.logs.unshift({
        type,
        message,
        timestamp: new Date().toLocaleTimeString('uk-UA')
      })

      // Keep only last 20 logs
      if (this.logs.length > 20) {
        this.logs = this.logs.slice(0, 20)
      }
    }
  },

  mounted() {
    this.addLog('info', 'Test page loaded')
    console.log('🧪 Test Bulk Access page mounted')
    console.log('Using mock data:', this.isUsingMock)
  }
}
</script>

<style scoped>
/* Add any custom styles if needed */
</style>
